import i18next from 'i18next';
import { roundWeight, stockingPhaseTypes } from '../../config/commons';

export const getAverageGrowthOrLarvaePerGram = (params: { phaseType: string; stage: number; averageWeight: number; larvaePerGram: number }) => {
  const { phaseType, averageWeight, stage, larvaePerGram } = params;

  if (phaseType === stockingPhaseTypes.ADULT) {
    return `${roundWeight({ value: averageWeight / (stage / 7), showUnit: false })} ${i18next.t('analysis.resultData.gramPerWeek')}`;
  }

  return `${larvaePerGram}`;
};

export const getAverageGrowthOrLarvaePerGramLabel = (phaseType: string) => {
  if (phaseType === stockingPhaseTypes.LARVAE) {
    return i18next.t('analysis.resultData.larvaePerGram');
  }
  if (phaseType === stockingPhaseTypes.ADULT) {
    return i18next.t('analysis.resultData.avgGrowth');
  }
  return i18next.t('analysis.resultData.juvenilePerGram');
};

export const roundAverageWeight = (params: { averageWeight: number; phaseType: string; forceCast?: boolean; showUnit?: boolean }) => {
  const { showUnit = true, phaseType, averageWeight, forceCast = false } = params;

  switch (phaseType) {
    case stockingPhaseTypes.LARVAE:
    case stockingPhaseTypes.ADULT:
      return roundWeight({ value: averageWeight, showUnit, forceCast });

    case stockingPhaseTypes.JUVENILE:
      return roundWeight({ value: averageWeight, forceCast: true, decimalPlaces: 3, showUnit });
  }

  return 0;
};

export const calcAvgGrowth = (props: { averageWeight: number; stage: number; phaseType: string; stockingWeight?: number }) => {
  const { averageWeight, phaseType, stage, stockingWeight = 0 } = props;

  switch (phaseType) {
    case stockingPhaseTypes.JUVENILE: {
      const unit = i18next.t('analysis.resultData.gramPerDay');

      if (stage === 0) {
        return `0 ${unit}`;
      }

      const value = (averageWeight / 1000) / (stage);
      return `${roundWeight({ value, showUnit: false, decimalPlaces: 3 })} ${unit}`;
    }
    case stockingPhaseTypes.ADULT: {
      const unit = i18next.t('analysis.resultData.gramPerWeek');

      if (stage === 0) {
        return `0 ${unit}`;
      }

      let value = (((averageWeight / 1000) - stockingWeight)) / ((stage) / 7);
      value = value < 0 ? 0 : value;
      return `${roundWeight({ value: value, showUnit: false })} ${unit}`;
    }
    default:
      return '';
  }
};